import { get } from 'lodash-es';
import { DEFAULT_LEASE_ANNUAL_MILEAGE } from 'site-modules/shared/constants/calculator/calculator';

/**
 * Builds a synthetic lease offer from estimateLeasePromise data
 * returned by /purchasefunnel/v2/displayvin/ API.
 *
 * This allows calling leasepayment API on VDP pageload without
 * waiting for lease-terms API response.
 *
 * @param {Object} vehicle - Vehicle data from Redux store
 * @returns {Object|null} - Offers object matching lease-terms API shape, or null if insufficient data
 */
export function buildOfferFromInventory(vehicle) {
  const lease = get(vehicle, 'prices.estimateLeasePromise');

  if (!lease?.residualValuePercentage) {
    return null;
  }

  const mileage = lease.mileage || DEFAULT_LEASE_ANNUAL_MILEAGE;
  const docFee = get(vehicle, 'prices.docFee', 0);

  return {
    annualMileage: {
      [String(mileage)]: [
        {
          term: lease.term,
          residual: lease.residualValuePercentage,
          moneyFactor: lease.moneyFactor,
          annualMileage: mileage,
          acquisitionFee: lease.acquisitionFee || 0,
          securityDeposit: lease.securityDeposit || 0,
          sellingPrice: lease.capCost,
          docFee,
        },
      ],
    },
  };
}
